<template>
    <div id="edit-library-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Edit User</h1>
                <template v-if="loaded">
                    <UserForm :formData="userObject" :agents="agents" submitText="Update" @formSubmitted="updateUser" />
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import UserForm from '@/components/forms/UserForm.vue'
const apiBase = process.env.VUE_APP_API_BASE
import axios from 'axios'
import { useAuthStore } from '@/stores/auth.js'

export default {
    name: 'UsersEdit',
    components: {
        UserForm
    },
    data: function() {
        return {
            userId: this.$route.params.id,
            userObject: null,
            agents: [],

            userLoaded: false,
            agentsLoaded: false
        }
    },
    computed: {
        loaded() {
            return this.userLoaded && this.agentsLoaded
        }
    },
    created() {
        axios.get(apiBase + '/users/' + this.userId)
                .then(response => {
                    this.userObject = response.data.data
                    this.userLoaded = true
                })
                .catch(error => {
                    alert('Could not load library!')
                    console.log(error)
                })

        const auth = useAuthStore()
        if (auth.role === 'agent') {
            this.agentsLoaded = true
        } else {
            axios.get(apiBase + '/agents')
                .then(response => {
                    this.agents = response.data.data
                    this.agentsLoaded = true
                })
                .catch(error => {
                    alert('Could not load agents!')
                    console.log(error)
                })
        }
    },
    methods: {
        updateUser(fd) {
            const auth = useAuthStore()
            const request = auth.role === 'agent'
                ? axios.patch(apiBase + '/users/' + this.userId, fd)
                : axios.put(apiBase + '/users/' + this.userId, fd)
            request
                  .then(response => {
                      console.log(response)
                      alert('User updated successfully')
                      //this.$router.push('/users')
                  })
                  .catch(error => {
                      console.log(error)
                      if (error.response?.data?.data) {
                          alert(error.response.data.data)
                      }
                      else {
                          alert('Error occurred!')
                      }
                  })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
